<template>
    <div class="statsDetailCell">
            <label class="time-label">{{ startTime }}</label>
            <div class="detail-cell">
                <div class="left-block">
                    <div class="team-block">
                        <b for="">{{ record.homeScore }}</b>
                        <img src="@/assets/football/players/event_mainPlace.png" alt="" v-if="showUpTeamInfo(true)"/>
                        <div class="space" v-if="showUpTeamInfo(false)"/>
                        <label for="">{{ record.homeTeam }}</label>
                    </div>
                </div>
                <div class="right-block">
                    <div class="score-detail">
                        <span v-if="showUpTeamInfo(true)">{{record.goal}}</span>
                        <span v-if="showUpTeamInfo(true)">{{record.pointSphere}}</span>
                        <span v-if="showUpTeamInfo(true)">{{record.uron}}</span>
                        <span v-if="showUpTeamInfo(true)">{{record.yellowCard}}</span>
                        <span v-if="showUpTeamInfo(true)">{{record.redCard}}</span>
                    </div>
                </div>
            </div>
            <div class="detail-cell">
                <div class="left-block">
                    <div class="team-block">
                        <b for="">{{ record.awayScore }}</b>
                        <img src="@/assets/football/players/event_mainPlace.png" alt="" v-if="showUpTeamInfo(false)"/>
                        <div class="space" v-if="showUpTeamInfo(true)"/>
                        <label for="">{{ record.awayTeam }}</label>
                    </div>
                </div>
                <div class="right-block">
                    <div class="score-detail">
                        <span v-if="showUpTeamInfo(false)">{{record.goal}}</span>
                        <span v-if="showUpTeamInfo(false)">{{record.pointSphere}}</span>
                        <span v-if="showUpTeamInfo(false)">{{record.uron}}</span>
                        <span v-if="showUpTeamInfo(false)">{{record.yellowCard}}</span>
                        <span v-if="showUpTeamInfo(false)">{{record.redCard}}</span>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
  name: 'statsDetailCell',
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    startTime: function () {
      var birthdayDate = new Date(this.record.startTime * 1000)
      return birthdayDate.toISOString().split('T')[0]
    }
  },
  methods: {
    showUpTeamInfo: function (isHome) {
      return isHome === Boolean(this.record.playerSide)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

// 下方对阵得分列表的容器
.statsDetailCell
    display: flex
    flex-direction: column
    padding: 6.5px 15px 6.5px 15px
    color: #999999
    font-size: 12px

    div:nth-child(2):not(:last-child)
        display: flex
        align-items: center
        padding-top: 9.5px

    div:nth-child(3)
        display: flex
        align-items: center
        padding-top: 2px

.detail-cell .time-label
    font-size: 10px
    color: #999999

.detail-cell .left-block
    width: 0
    padding-right: 15px
    flex-grow: 4
    img
        padding-left: 10px
        width: 12px
        height: 12px

.left-block .team-block
    display: flex
    align-items: center
    color: #333333
    font-size: 12px

    b:nth-child(1)
        background-color: #eff0f3
        width: 16px
        height: 16px
        display: flex
        align-items: center
        justify-content: center

    label:nth-child(3)
        padding-left: 4px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis

.detail-cell .right-block
    width: 0
    flex-grow: 6

.right-block .score-detail
    display: flex
    justify-content: space-between
    text-align: center
    span
        color: #333333
        width: 30px

.space
    width: 12px
    height: 12px
    padding-left: 10px
</style>
